export default "__VITE_ASSET__D72_uh68__"